import { useEffect, useRef } from "react";

const DRAWER_WIDTH = 432;

/**
 * Keeps the bay grid at its original width while the settings drawer is open,
 * and limits the visible scroll area to the space beside the drawer.
 */
export function useSegmentsBesideDrawer(open: boolean) {
  const containerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const container = containerRef.current;
    const table = container?.querySelector<HTMLElement>(".segments-table");
    if (!container || !table) {
      return;
    }

    const clear = () => {
      container.style.width = "";
      table.style.width = "";
      table.style.minWidth = "";
    };

    if (!open) {
      clear();
      return;
    }

    const fit = () => {
      clear();
      const parent = container.parentElement;
      if (!parent) {
        return;
      }

      const parentRect = parent.getBoundingClientRect();
      const drawerLeft = window.innerWidth - DRAWER_WIDTH;
      const visibleWidth = Math.min(parentRect.width, Math.max(0, drawerLeft - parentRect.left));
      if (visibleWidth <= 0 || visibleWidth >= parentRect.width - 1) {
        return;
      }

      container.style.width = `${visibleWidth}px`;
      table.style.width = `${parentRect.width}px`;
      table.style.minWidth = `${parentRect.width}px`;
    };

    fit();
    window.addEventListener("resize", fit);
    return () => {
      window.removeEventListener("resize", fit);
      clear();
    };
  }, [open]);

  return containerRef;
}
